import { Component } from '@angular/core';

@Component({
  selector: 'app-interview-thanks',
  templateUrl: './interview-thanks.component.html',
  styleUrls: ['./interview-thanks.component.scss'],
})
export class InterviewThanksComponent {}
